<template>
  <div>
    <div class="row d-flex justify-content-center">
      <div class="col-lg-12">
        <template class="header">
          <h4 class="card-title style-title">Customer Registration</h4>
          <h5 class="description style-title">
            Please fill in all the required details to add new Customer Waste
            Collection Schedule.
          </h5>
        </template>
      </div>
    </div>
    <div class="row d-flex justify-content-center">
      <div class="col-lg-12">
        <card>
          <div class="row justify-content-center">
            <div class="col-lg-12">
              <h4 class="card-title style-title">Customer Details</h4>
            </div>
          </div>
          <div class="row justify-content-center">
            <div class="col-lg-6">
              <base-input
                label="1. Customer Name"
                placeholder="Customer"
                v-model="customer"
                type="text"
              >
              </base-input>
              <base-input
                label="2. Customer Password"
                placeholder="Password"
                v-model="password"
                type="password"
              >
              </base-input>
              <base-input
                label="3. Customer Address"
                placeholder="Address"
                v-model="address"
                type="text"
              >
              </base-input>
            </div>
            <div class="col-lg-6">
              <base-input
                label="4. Customer Phone No."
                placeholder="Phone No"
                v-model="phoneNo"
                type="number"
              >
              </base-input>
              <base-input
                label="5. Customer Email"
                placeholder="Email"
                v-model="email"
                type="email"
              >
              </base-input>
              <base-input
                label="6. Person in Charge"
                placeholder="PIC"
                v-model="pic"
                type="text"
              >
              </base-input>
            </div>
          </div>
          <div class="row justify-content-center">
            <base-button type="primary" @click="registerCustomer()"
              >Register Customer</base-button
            >
          </div>
        </card>
      </div>
    </div>
    <div class="row d-flex justify-content-center">
      <div class="col-lg-12">
        <card>
          <div class="row justify-content-center">
            <div class="col-lg-12">
              <h4 class="card-title style-title">Pickup Details</h4>
            </div>
          </div>
          <div class="row justify-content-center">
            <!-- Select Site/Route, PickupPoint Name and Lat/Long -->
            <div class="col-lg-2">
              <base-input label="1. Region">
                <el-select
                  class="select-danger"
                  placeholder="Region"
                  v-model="region"
                  @change="getRoute(region)"
                  :disabled="pickup"
                >
                  <el-option
                    v-for="a in regions"
                    class="select-danger"
                    :value="a.value"
                    :label="a.label"
                    :key="a"
                  ></el-option>
                </el-select>
              </base-input>
              <base-input label="2. Select Site / Route">
                <el-select
                  class="select-danger"
                  placeholder="Site/Route"
                  v-model="route"
                  :disabled="pickup"
                >
                  <el-option
                    v-for="b in routes"
                    class="select-danger"
                    :value="b.value"
                    :label="b.label"
                    :key="b"
                  ></el-option>
                </el-select>
              </base-input>
              <base-input
                label="3. Pickup Point Name"
                placeholder="Pickup Point"
                v-model="pickupPoint"
                :disabled="pickup"
              ></base-input>
              <base-input
                label="4. Latitude"
                placeholder="Latitude"
                v-model="lat"
                :disabled="pickup"
              ></base-input>
              <base-input
                label="5. Longitude"
                placeholder="Longitude"
                v-model="long"
                :disabled="pickup"
              ></base-input>
              <base-input
                label="6. Radius (in meter)"
                placeholder="Radius"
                v-model="radius"
                :disabled="pickup"
              ></base-input>
              <base-input label="7. Landsite or Airside">
                <el-select
                  class="select-danger"
                  placeholder="select"
                  v-model="airsidelandside"
                  :disabled="pickup"
                >
                  <el-option
                    v-for="b in side"
                    class="select-danger"
                    :value="b.value"
                    :label="b.label"
                    :key="b"
                  ></el-option>
                </el-select>
              </base-input>
            </div>

            <!-- Frequecy of Pickup -->
            <div class="col-lg-4" style="margin-left: 2%">
              <div class="row">
                <div class="col-lg-12 text-center">
                  <label style="font-size: 16px">8. Frequency of pickup</label>
                </div>
                <div class="row ml-auto mr-auto group-form">
                  <div class="col-lg-6">
                    <div class="row">
                      <label class="col-md-5 col-form-label">MON:</label>
                      <div class="col-lg-7 select-day">
                        <base-input>
                          <el-select
                            class="select-danger"
                            placeholder="Day"
                            v-model="monday"
                            :disabled="pickup"
                          >
                            <el-option
                              v-for="c in selects.totalPickup"
                              class="select-danger"
                              :value="c.value"
                              :label="c.label"
                              :key="c.label"
                            ></el-option>
                          </el-select>
                        </base-input>
                      </div>
                      <label class="col-md-5 col-form-label">TUE:</label>
                      <div class="col-lg-7 select-day">
                        <base-input>
                          <el-select
                            class="select-danger"
                            placeholder="Day"
                            v-model="tuesday"
                            :disabled="pickup"
                          >
                            <el-option
                              v-for="d in selects.totalPickup"
                              class="select-danger"
                              :value="d.value"
                              :label="d.label"
                              :key="d.label"
                            ></el-option>
                          </el-select>
                        </base-input>
                      </div>
                      <label class="col-md-5 col-form-label">WED:</label>
                      <div class="col-lg-7 select-day">
                        <base-input>
                          <el-select
                            class="select-danger"
                            placeholder="Day"
                            v-model="wednesday"
                            :disabled="pickup"
                          >
                            <el-option
                              v-for="e in selects.totalPickup"
                              class="select-danger"
                              :value="e.value"
                              :label="e.label"
                              :key="e.label"
                            ></el-option>
                          </el-select>
                        </base-input>
                      </div>
                      <label class="col-md-5 col-form-label">THU:</label>
                      <div class="col-lg-7 select-day">
                        <base-input>
                          <el-select
                            class="select-danger"
                            placeholder="Day"
                            v-model="thursday"
                            :disabled="pickup"
                          >
                            <el-option
                              v-for="f in selects.totalPickup"
                              class="select-danger"
                              :value="f.value"
                              :label="f.label"
                              :key="f.label"
                            ></el-option>
                          </el-select>
                        </base-input>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-6">
                    <div class="row">
                      <label class="col-md-5 col-form-label">FRI:</label>
                      <div class="col-lg-7 select-day">
                        <base-input>
                          <el-select
                            class="select-danger"
                            placeholder="Day"
                            v-model="friday"
                            :disabled="pickup"
                          >
                            <el-option
                              v-for="g in selects.totalPickup"
                              class="select-danger"
                              :value="g.value"
                              :label="g.label"
                              :key="g.label"
                            ></el-option>
                          </el-select>
                        </base-input>
                      </div>
                    </div>
                    <div class="row">
                      <label class="col-md-5 col-form-label">SAT:</label>
                      <div class="col-lg-7 select-day">
                        <base-input>
                          <el-select
                            class="select-danger"
                            placeholder="Day"
                            v-model="saturday"
                            :disabled="pickup"
                          >
                            <el-option
                              v-for="h in selects.totalPickup"
                              class="select-danger"
                              :value="h.value"
                              :label="h.label"
                              :key="h.label"
                            ></el-option>
                          </el-select>
                        </base-input>
                      </div>
                    </div>
                    <div class="row">
                      <label class="col-md-5 col-form-label">SUN:</label>
                      <div class="col-lg-7 select-day">
                        <base-input>
                          <el-select
                            class="select-danger"
                            placeholder="Day"
                            v-model="sunday"
                            :disabled="pickup"
                          >
                            <el-option
                              v-for="i in selects.totalPickup"
                              class="select-danger"
                              :value="i.value"
                              :label="i.label"
                              :key="i.label"
                            ></el-option>
                          </el-select>
                        </base-input>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Type of Bin -->
            <div class="col-lg-5" style="margin-left: 2%">
              <div class="row">
                <div class="col-lg-12 text-center">
                  <label style="font-size: 16px">9. Type of Bin</label>
                </div>
                <div class="row ml-auto mr-auto group-form">
                  <div
                    class="col-lg-6"
                    v-for="(items, index) in label"
                    :key="items"
                  >
                    <div class="row">
                      <label class="col-md-6 col-form-label">{{
                        items.label
                      }}</label>
                      <div class="col-lg-6 select-day">
                        <base-input
                          class="danger"
                          placeholder="Bin"
                          v-model="mod[index]"
                          type="number"
                          :disabled="pickup"
                        >
                        </base-input>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-12 text-center">
              <el-link
                href="./img/csv/CustomerRegistration.csv"
                class="mt-3"
                type="primary"
                >Download CSV template</el-link
              >
              &nbsp;
              <!--:disabled="pickup" -->
              <base-button
                @click="modalsCSV = true"
                native-type="submit"
                type="green"
                simple
                :disabled="pickup"
              >
                Import with CSV </base-button
              >&nbsp;
              <base-button
                @click="getPickupFrequency()"
                type="primary"
                :disabled="pickup"
                >Add Schedule</base-button
              >
            </div>
            <modal
              :show.sync="modalsCSV"
              footer-classes="justify-content-center"
              type="notice"
            >
              <h3 slot="header" class="modal-title">Import CSV Form</h3>
              <div class="modal-body">
                <div class="row">
                  <div class="col-md-12 text-center">
                    <label id="fileName">{{ fileName }}</label>
                    <span class="btn btn-info btn-file">
                      <span class="fileinput-new">Choose File</span>
                      <input
                        accept=".csv"
                        type="file"
                        class="valid"
                        :multiple="false"
                        @change="importCsv"
                      />
                    </span>
                  </div>
                </div>
              </div>
              <template slot="footer">
                <!-- <base-button
                        @click="send()"
                        :disabled="disabledsend"
                        class="mt-3"
                        native-type="submit"
                        type="success"
                    >Submit</base-button>&nbsp;&nbsp;&nbsp; -->
                <base-button
                  class="mt-3"
                  type="danger"
                  @click.native="modalsCSV = false"
                  >Cancel</base-button
                >
              </template>
            </modal>
          </div>
          <div class="col-sm-12">
            <hr />
          </div>
          <div class="col-sm-12 text-center" style="margin-top: 2%">
            <h3>Schedule Details</h3>
          </div>
          <div class="col-sm-12">
            <el-table
              :data="tableData"
              style="border: solid white; border-radius: 10px"
              :header-cell-style="{
                background: 'transparent',
                border: 'none',
                borderBottom: '0.5px solid #3d3f51',
              }"
              :cell-style="{
                border: 'none',
                borderBottom: '0.5px solid #3d3f51',
              }"
            >
              <el-table-column
                min-width="120"
                sortable
                align="center"
                label="Region"
                property="region"
              ></el-table-column>
              <el-table-column
                min-width="120"
                sortable
                align="center"
                label="Site / Route"
                property="siteRoute"
              ></el-table-column>
              <el-table-column
                min-width="120"
                sortable
                align="center"
                label="Pickup Point"
                property="pickupPoint"
              ></el-table-column>
              <el-table-column
                min-width="120"
                sortable
                align="center"
                label="Latitude"
                property="latitude"
              ></el-table-column>
              <el-table-column
                min-width="120"
                sortable
                align="center"
                label="Longitude"
                property="longitude"
              ></el-table-column>
              <el-table-column
                min-width="120"
                sortable
                align="center"
                label="Total Pickup"
                property="totalPickup"
              ></el-table-column>
              <el-table-column
                min-width="100"
                sortable
                align="center"
                label="Total Bins"
                property="totalBins"
              ></el-table-column>
              <el-table-column :min-width="45" align="right">
                <div slot-scope="props">
                  <el-tooltip
                    content="Delete"
                    placement="bottom"
                    effect="light"
                  >
                    <base-button
                      @click.native="handleDelete(props.$index, props.row)"
                      class="remove btn-link"
                      type="danger"
                      size="sm"
                      icon
                    >
                      <i class="tim-icons icon-simple-remove"></i>
                    </base-button>
                  </el-tooltip>
                </div>
              </el-table-column>
            </el-table>
          </div>
          <div class="d-flex justify-content-center spinner" v-if="load">
            <circle-8></circle-8>
          </div>
          <div class="col-lg-12 text-center">
            <base-button type="primary" @click="submit()" :disabled="pickup"
              >Submit</base-button
            >&nbsp;
          </div>
        </card>
      </div>
    </div>
  </div>
</template>
<script>
import { Select, Option } from "element-ui";
import { Table, TableColumn, Link } from "element-ui";
import swal from "sweetalert2";
import { ImageUpload, Modal } from "src/components/index";
import { Circle8 } from "vue-loading-spinner";
// const VueCsvImport = window["vue-csv-import"].VueCsvImport;

export default {
  components: {
    ImageUpload,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    Modal,
    Circle8,
    [Link.name]: Link,
  },
  data() {
    return {
      load: false,
      fileName: "",
      modalsCSV: false,
      mod: [],
      value: [],
      regions: [],
      routes: [],
      customer: "",
      custID: "",
      password: "",
      address: "",
      phoneNo: "",
      email: "",
      pic: "",
      region: "",
      route: "",
      airsidelandside: "",
      monday: 0,
      tuesday: 0,
      wednesday: 0,
      thursday: 0,
      friday: 0,
      saturday: 0,
      sunday: 0,
      pickupPoint: "",
      lat: "",
      long: "",
      radius: "",
      label: [],
      items: {
        labels: [],
      },
      side: [
        { value: "1", label: "Airside" },
        { value: "2", label: "Landside" },
      ],
      selects: {
        totalPickup: [
          { value: "0", label: "0" },
          { value: "1", label: "1" },
          { value: "2", label: "2" },
          { value: "3", label: "3" },
          { value: "4", label: "4" },
          { value: "5", label: "5" },
        ],
      },
      pickup: true,
      // Table
      tableData: [],
      routecsv: [],
      sendData: [],
      ppstats: [],
      csvValue: "No file selected",
      modals: {
        upload: false,
      },
      csvdata: [],
    };
  },
  created() {
    this.getRegion();
    this.getRoutecsv();
    this.getPPStat();
    this.getBinType();
    //   this.getBinType();
  },
  methods: {
    getBinType() {
      this.$http.get(":9991/api/v1/setting/bin").then((res) => {
        if (!res.error) {
          let response = res.message;
          console.log(response);
          for (var i = 0; i < response.length; i++) {
            let binTypeData = {
              label: response[i].binname,
              id: response[i].BintypeID,
            };
            this.label.push(binTypeData);
          }

          console.log(this.label);
        } else {
          swal({
            title: "Data Error!",
            text: `${res.message}`,
            type: "warning",
            confirmButtonClass: "btn btn-success btn-fill",
            confirmButtonText: "Okay",
            buttonsStyling: false,
          });
        }
      });
    },
    getRegion() {
      this.$http.get(":9991/api/v1/customers/region").then((res) => {
        if (!res.error) {
          let response = res.message;
          console.log(response);
          for (var i = 0; i < response.length; i++) {
            let data = {
              label: response[i].RegionName,
              value: response[i].RegionID,
            };
            console.log(data);
            this.regions.push(data);
          }
        } else {
          swal({
            title: "Data Error!",
            text: `${res.message}`,
            type: "warning",
            confirmButtonClass: "btn btn-success btn-fill",
            confirmButtonText: "Okay",
            buttonsStyling: false,
          });
        }
      });
      this.region = [];
    },
    getRoute(regionID) {
      console.log(regionID);
      this.$http
        .post(":9991/api/v1/customers/routeList/" + regionID)
        .then((res) => {
          if (!res.error) {
            let response = res.message;
            console.log(response);
            for (var i = 0; i < response.length; i++) {
              let data = {
                label: response[i].RouteName,
                value: response[i].RouteID,
              };
              console.log(data);
              this.routes.push(data);
            }
          } else {
            swal({
              title: "Data Error!",
              text: `${res.message}`,
              type: "warning",
              confirmButtonClass: "btn btn-success btn-fill",
              confirmButtonText: "Okay",
              buttonsStyling: false,
            });
          }
        });
      this.routes = [];
    },
    getRoutecsv() {
      this.$http.get(":9991/api/v1/customers/route").then((res) => {
        if (!res.error) {
          let response = res.message;
          console.log(response);
          for (var i = 0; i < response.length; i++) {
            let data = {
              routename: response[i].RouteName,
              routeid: response[i].RouteID,
            };

            this.routecsv.push(data);
          }
        }
      });
    },
    getPPStat() {
      this.$http.get(":9991/api/v1/customers/ppstat").then((res) => {
        if (!res.error) {
          let response = res.message;
          console.log(response);
          for (var i = 0; i < response.length; i++) {
            let data = {
              ppstatid: response[i].PPStatID,
              ppstatname: response[i].StatName,
            };

            this.ppstats.push(data);
          }
        }
      });
    },
    registerCustomer() {
      console.log(this.customer);
      console.log(this.password);
      console.log(this.address);
      console.log(this.phoneNo);
      console.log(this.email);
      console.log(this.pic);
      // validate email
      var emailFormat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
      if (this.email.match(emailFormat)) {
        console.log("email valid");
        // validate phone number
        console.log(this.phoneNo.length);
        if (this.phoneNo.length >= 9) {
          console.log("phone number valid");
          if (
            this.customer === "" ||
            this.password === "" ||
            this.phoneNo === "" ||
            this.pic === ""
          ) {
            swal({
              title: "Data Error!",
              text: "Customer form cannot be empty",
              type: "warning",
              confirmButtonClass: "btn btn-success btn-fill",
              confirmButtonText: "Okay",
              buttonsStyling: false,
            });
          } else {
            let payload = {
              name: this.customer,
              password: this.password,
              address: this.address,
              phoneno: this.phoneNo,
              email: this.email,
              pic: this.pic,
            };
            // save to customer table
            this.$http
              .post(":9991/api/v1/customers/registration", payload)
              .then((res) => {
                if (!res.error) {
                  let response = res.message;
                  console.log(response);
                  this.custID = response;
                  swal({
                    title: "Successfull!",
                    text: "Customer successfully created",
                    type: "success",
                    confirmButtonClass: "btn btn-success btn-fill",
                    confirmButtonText: "Okay",
                    buttonsStyling: false,
                  });
                  this.customer = "";
                  this.password = "";
                  this.address = "";
                  this.phoneNo = "";
                  this.email = "";
                  this.pic = "";
                  this.pickup = false;
                } else {
                  swal({
                    title: "Data Error!",
                    text: `${res.message}`,
                    type: "warning",
                    confirmButtonClass: "btn btn-success btn-fill",
                    confirmButtonText: "Okay",
                    buttonsStyling: false,
                  });
                }
              });
            console.log(payload);
            console.log("All data validated!!!");
          }
        } else {
          swal({
            title: "Data Error!",
            text: "Phone number not valid",
            type: "warning",
            confirmButtonClass: "btn btn-success btn-fill",
            confirmButtonText: "Okay",
            buttonsStyling: false,
          });
        }
      } else {
        swal({
          title: "Data Error!",
          text: "Email not valid",
          type: "warning",
          confirmButtonClass: "btn btn-success btn-fill",
          confirmButtonText: "Okay",
          buttonsStyling: false,
        });
      }
    },
    getPickupFrequency() {
      // check empty form
      if (
        this.region === "" ||
        this.route === "" ||
        this.pickupPoint === "" ||
        this.lat === "" ||
        this.long === "" ||
        this.monday === "" ||
        this.tuesday === "" ||
        this.wednesday === "" ||
        this.thursday === "" ||
        this.friday === "" ||
        this.saturday === "" ||
        this.sunday === "" ||
        this.airsidelandside === ""
      ) {
        swal({
          title: "Data Error!",
          text: "Pickup form cannot be empty",
          type: "warning",
          confirmButtonClass: "btn btn-success btn-fill",
          confirmButtonText: "Okay",
          buttonsStyling: false,
        });
      } else {
        console.log(this.region);
        console.log(this.route);
        console.log(this.pickupPoint);
        console.log(this.lat);
        console.log(this.long);
        console.log(this.monday);
        console.log(this.tuesday);
        console.log(this.wednesday);
        console.log(this.thursday);
        console.log(this.friday);
        console.log(this.saturday);
        console.log(this.sunday);
        console.log(this.custID);
        console.log(this.radius);
        console.log(this.label);
        console.log(this.airsidelandside);
        let binData = [];

        // combine pickup frequency into array
        let pickupFrequency = [
          parseInt(this.monday),
          parseInt(this.tuesday),
          parseInt(this.wednesday),
          parseInt(this.thursday),
          parseInt(this.friday),
          parseInt(this.saturday),
          parseInt(this.sunday),
        ];
        console.log(pickupFrequency);
        console.log(this.mod);
        let binPayload = null;
        let quantity = [];

        for (var i = 0; i < this.mod.length; i++) {
          binPayload = {
            bintypeid: this.label[i].id,
            quantity: parseInt(this.mod[i]),
          };

          quantity.push(parseInt(this.mod[i]));

          console.log(binPayload);
          binData.push(binPayload);
          // quantity.push(qty)
        }

        let pickupPointPayload = {
          routeid: this.route,
          custid: this.custID,
          regionid: this.region,
          pickupname: this.pickupPoint,
          PickupFreq: pickupFrequency,
          pickuplat: parseFloat(this.lat),
          pickuplong: parseFloat(this.long),
          binlist: binData,
          radius: this.radius,
          ppstatid: this.airsidelandside,
        };
        // map route id to find route name
        for (var i = 0; i < this.routes.length; i++) {
          if (this.route === this.routes[i].value) {
            this.route = this.routes[i].label;
          }
        }

        // map region id to find region name
        for (var i = 0; i < this.regions.length; i++) {
          if (this.region === this.regions[i].value) {
            this.region = this.regions[i].label;
          }
        }

        // sum of bin data
        let sum = 0;
        for (var i = 0; i < quantity.length; i++) {
          sum += quantity[i];
        }
        let total = 0;
        for (var i = 0; i < pickupFrequency.length; i++) {
          total += pickupFrequency[i];
        }
        console.log(sum);

        let pickupPointTable = {
          siteRoute: this.route,
          region: this.region,
          pickupPoint: this.pickupPoint,
          totalPickup: total,
          latitude: parseFloat(this.lat),
          longitude: parseFloat(this.long),
          totalBins: sum,
        };

        console.log(pickupPointPayload);
        // send
        this.sendData.push(pickupPointPayload);
        // display
        this.tableData.push(pickupPointTable);

        (this.region = ""),
          (this.airsidelandside = ""),
          (this.route = ""),
          (this.pickupPoint = ""),
          (this.lat = ""),
          (this.long = ""),
          (this.radius = ""),
          (this.monday = 0),
          (this.tuesday = 0),
          (this.wednesday = 0),
          (this.thursday = 0),
          (this.friday = 0),
          (this.saturday = 0),
          (this.sunday = 0),
          (this.mod = []);
      }
    },
    handleDelete(index, row) {
      console.log(index);
      console.log(row);
      this.tableData.pop(index);
      this.sendData.pop(index);
      // console.log(userDetails)
      // userDetails = []
    },
    submit() {
      this.load = true;
      console.log(this.sendData);
      // checking input
      if (this.sendData.length === 0) {
        swal({
          title: "Data Error!",
          text: "No data",
          type: "warning",
          confirmButtonClass: "btn btn-success btn-fill",
          confirmButtonText: "Okay",
          buttonsStyling: false,
        });
      } else {
        console.log(this.tableData);
        console.log(this.sendData);
        let data = {
          data: this.sendData,
        };
        console.log(data);
        this.$http.post(":9991/api/v1/customers/pickup", data).then((res) => {
          if (!res.error) {
            let response = res.message;
            console.log(response);
            swal({
              title: "Successfull!",
              text: "Customer successfully created",
              type: "success",
              confirmButtonClass: "btn btn-success btn-fill",
              confirmButtonText: "Okay",
              buttonsStyling: false,
            });
            this.tableData = [];
            this.sendData = [];
          } else {
            swal({
              title: "Data Error!",
              text: `${res.message}`,
              type: "warning",
              confirmButtonClass: "btn btn-success btn-fill",
              confirmButtonText: "Okay",
              buttonsStyling: false,
            });
          }
          this.load = false;
        });
      }
    },
    importCsv(data) {
      console.log(data);
      const file = data.target.files[0];
      const reader = new FileReader();
      reader.readAsText(file);
      this.fileName = file.name;
      reader.onload = (e) => {
        const userDetails = [
          // "custid",
          // "routeid",
          "Route",
          // "regionid",
          "Region",
          "PickupPoint",
          "Monday",
          "Tuesday",
          "Wednesday",
          "Thursday",
          "Friday",
          "Saturday",
          "Sunday",
          "Latitude",
          "Longitude",
          "Radius",
          "BinType",
          "Quantity",
        ];

        let header;
        let lines = [];
        let csv = e.target.result; // Content from file
        console.log(csv);
        let allTextLines = csv.split(/\r\n|\n/);
        console.log(allTextLines);
        for (let i = 0; i < allTextLines.length; i++) {
          if (i == 0) {
            header = allTextLines[i].split(",");
          } else {
            lines.push(allTextLines[i].split(","));
          }
        }
        // check header
        if (
          header[0] !== "Route" ||
          header[1] !== "Region" ||
          header[2] !== "Pickup Point" ||
          header[3] !== "Monday" ||
          header[4] !== "Tuesday" ||
          header[5] !== "Wednesday" ||
          header[6] !== "Thursday" ||
          header[7] !== "Friday" ||
          header[8] !== "Saturday" ||
          header[9] !== "Sunday" ||
          header[10] !== "Latitude" ||
          header[11] !== "Longitude" ||
          header[12] !== "Radius" ||
          header[13] !== "PP stat" ||
          header[14] !== "Bin Type" ||
          header[15] !== "Quantity" ||
          header[16] !== "BinType" ||
          header[17] !== "Quantity"
        ) {
          // let img = "@/assets/img/schedule-csv.PNG"
          swal({
            title: "Header Error!",
            html: '<b>Make sure you follow the predefined header as below:</b><img width="100%" height="100%" src="img/greencard-csv.PNG"><img width="80%" height="100%" src="img/greencard2-csv.PNG">',
            type: "warning",
            confirmButtonClass: "btn btn-success btn-fill",
            confirmButtonText: "Okay",
            buttonsStyling: false,
          });
        } else {
          lines.pop();
          console.log(lines[14]);
          console.log(header);

          console.log(header.length);
          // let binData = lines[15]
          let bintype = [];
          let qty = [];
          console.log(lines);
          console.log(lines.length);
          for (var i = 0; i < lines.length; i++) {
            console.log(lines[i].length);
            for (var j = 0; j < lines[i].length; j++) {
              if (j >= 14) {
                if (j % 2 == 0) {
                  // even number
                  let routeregion = {
                    route: lines[i][0],
                    region: lines[i][1],
                    bintype: lines[i][j],
                  };
                  bintype.push(routeregion);
                  // binname = lines[i][j]
                } else {
                  let routeregion2 = {
                    route: lines[i][0],
                    region: lines[i][1],
                    qty: parseInt(lines[i][j]),
                  };
                  qty.push(routeregion2);
                  // qty = lines[i][j]
                }
              }
            }

            console.log(bintype);
            console.log(qty);
          }
          let err = [];
          let data = [];
          for (var i = 0; i < lines.length; i++) {
            for (var j = 0; j < bintype.length; j++) {
              if (lines[i][0] === bintype[j].route) {
                if (lines[i][1] === bintype[j].region) {
                  let data = {
                    route: bintype[j].route,
                    region: bintype[j].region,
                    binname: bintype[j].bintype,
                    qty: qty[j].qty,
                  };

                  err.push(data);
                }
              }
            }
            let name = [];
            let qtybin = [];
            for (var j = 0; j < err.length; j++) {
              if (lines[i][0] === err[j].route) {
                name.push(err[j].binname);
                qtybin.push(qty[j].qty);
              }
            }
            console.log(name);
            console.log(qtybin);

            let susundata = {
              route: lines[i][0],
              region: lines[i][1],
              pickuppoint: lines[i][2],
              monday: lines[i][3],
              tuesday: lines[i][4],
              wednesday: lines[i][5],
              thursday: lines[i][6],
              friday: lines[i][7],
              saturday: lines[i][8],
              sunday: lines[i][9],
              latitude: lines[i][10],
              longitude: lines[i][11],
              radius: lines[i][12],
              ppstat: lines[i][13],
              binname: name,
              quantity: qtybin,
            };

            data.push(susundata);
          }
          console.log(data);
          let routeflag = 0;
          let regionflag = 0;
          let ppflag = 0;

          // sumation of quantity of bin
          for (var i = 0; i < data.length; i++) {
            // check customer
            // calculate sum bin
            let sumqty = data[i].quantity.reduce((a, b) => a + b);
            console.log(sumqty);

            // calculate total pickup
            let totalpickup =
              parseInt(data[i].monday) +
              parseInt(data[i].tuesday) +
              parseInt(data[i].wednesday) +
              parseInt(data[i].thursday) +
              parseInt(data[i].friday) +
              parseInt(data[i].saturday) +
              parseInt(data[i].sunday);
            console.log(totalpickup);

            // find id for everything
            let routeid = "";
            for (var j = 0; j < this.routecsv.length; j++) {
              console.log(this.routecsv[j].routename);
              if (data[i].route == this.routecsv[j].routename) {
                routeid = this.routecsv[j].routeid;
                routeflag = 1;
              }
            }
            if (routeid == "") {
              routeflag = 0;
              swal({
                title: "Data Error!",
                text:
                  "Route " +
                  data[i].route +
                  " for pickup point " +
                  data[i].pickuppoint +
                  " does not exist!",
                type: "warning",
                confirmButtonClass: "btn btn-success btn-fill",
                confirmButtonText: "Okay",
                buttonsStyling: false,
              });
            }

            let regionid = "";
            for (var j = 0; j < this.regions.length; j++) {
              if (data[i].region == this.regions[j].label) {
                regionid = this.regions[j].value;
                regionflag = 1;
              }
            }
            console.log(regionid);
            if (regionid == "") {
              regionflag = 0;
              swal({
                title: "Data Error!",
                text:
                  "Region " +
                  data[i].region +
                  " for pickup point " +
                  data[i].pickuppoint +
                  " does not exist!",
                type: "warning",
                confirmButtonClass: "btn btn-success btn-fill",
                confirmButtonText: "Okay",
                buttonsStyling: false,
              });
            }

            let ppstatid = "";
            for (var j = 0; j < this.ppstats.length; j++) {
              console.log(this.ppstats[j].ppstatname);
              if (data[i].ppstat === this.ppstats[j].ppstatname) {
                ppstatid = this.ppstats[j].ppstatid;
                ppflag = 1;
              }
            }

            if (ppstatid == "") {
              ppflag = 0;
              swal({
                title: "Data Error!",
                text:
                  "Region " +
                  data[i].ppstat +
                  " for pickup point " +
                  data[i].pickuppoint +
                  " does not exist!",
                type: "warning",
                confirmButtonClass: "btn btn-success btn-fill",
                confirmButtonText: "Okay",
                buttonsStyling: false,
              });
            }

            console.log(routeid);
            console.log(regionid);
            console.log(ppstatid);
            let bin = [];
            let id = "";
            console.log(data[0].binname.length);
            for (var j = 0; j < data[i].binname.length; j++) {
              for (var k = 0; k < this.label.length; k++) {
                if (data[i].binname[j] === this.label[k].label) {
                  let bindata = {
                    bintypeid: this.label[k].id,
                    quantity: data[i].quantity[j],
                  };
                  bin.push(bindata);
                }
              }
            }
            console.log(bin);
            // susun bin type & quantity
            let payloadtable = {
              siteRoute: data[i].route,
              // custid: csvFilter.custid,
              region: data[i].region,
              pickupPoint: data[i].pickuppoint,
              totalPickup: totalpickup,
              latitude: parseFloat(data[i].latitude),
              longitude: parseFloat(data[i].longitude),
              totalBins: sumqty,
            };

            this.tableData.push(payloadtable);

            let pickupPointPayload = {
              routeid: routeid,
              custid: this.custID,
              regionid: regionid,
              pickupname: data[i].pickuppoint,
              PickupFreq: [
                parseInt(data[i].monday),
                parseInt(data[i].tuesday),
                parseInt(data[i].wednesday),
                parseInt(data[i].thursday),
                parseInt(data[i].friday),
                parseInt(data[i].saturday),
                parseInt(data[i].sunday),
              ],
              pickuplat: parseFloat(data[i].latitude),
              pickuplong: parseFloat(data[i].longitude),
              ppstatid: ppstatid,
              binlist: bin,
              radius: data[i].radius,
            };

            console.log(pickupPointPayload);
            // push to send array
            this.sendData.push(pickupPointPayload);
            console.log(this.sendData);
          }
          if (routeflag == 0 || regionflag == 0 || ppflag == 0) {
            this.tableData = [];
            this.sendData = [];
          }
          this.modalsCSV = false;
        }
      };
    },
    submitData() {
      let finalpayload = "";
      console.log(this.csvdata);
      if (this.csvdata.length === 0) {
        console.log("CALLED 1");
        finalpayload = {
          userlist: [
            {
              siteRoute: line[0].toString(),
              region: line[1].toString(),
              pickupPoint: line[2].toString(),
              totalPickup: line[3].toString(),
              latitude: line[4].toString(),
              longitude: line[5].toString(),
              totalBins: line[6].toString(),
            },
          ],
        };
      } else {
        console.log("CALLED 2");
        console.log(this.csvdata);

        finalpayload = {
          userlist: this.csvdata,
        };
      }

      this.$http.post(":9992/api/v1/admin/user", finalpayload).then((res) => {
        console.log(res);
        if (!res.error) {
          swal({
            title: "Success!",
            text: res.message,
            type: "success",
            confirmButtonClass: "btn btn-success btn-fill",
            buttonsStyling: false,
          });
        } else {
          swal({
            title: "Error!",
            text: res.message,
            type: "error",
            confirmButtonClass: "btn btn-success btn-fill",
            buttonsStyling: false,
          });
        }
      });
    },
  },
};
</script>

<style scoped>
.style-title {
  text-align: center;
}
</style>
